import cloneDeep from 'lodash.clonedeep'
import { isEmpty } from './objectFn'

/**
 * Constructing and stringifying query parameters to be used as payload in service calls. This is formatted 
 * so C# can read it as a Dictionary<string, string> from body.
 * @param {Object} target - The target object to construct from.
 * @param {...Object} assignValues - Assigning extra values to the target.
 */
export function toQueryParameters(target, ...assignValues) {
    let queryParameters = cloneDeep(Object(target));
    
    // Assign values to target
    Object.entries(queryParameters).forEach(t => {
        assignValues.forEach(assignValue => {
            if (t[1] === Object(t[1])) {
                Object.assign(t[1], ...Object.entries(assignValue).map(([key, value]) => ({
                    [key]: Array.isArray(value) ? value.slice().join(',') : value
                })));
            }
        });
    });

    if (isEmpty(queryParameters)) return queryParameters;

    // Format output as queryParameters
    return Object.assign( 
        ...Object.entries(queryParameters).map(([key, value]) => ({ 
            [key]: JSON.stringify(value)
        }))
    )
}

/**
 * Parsing from query parameters to plain Object.
 * @param {Object} queryParameters - The query parameters to parse.
 */
export function fromQueryParameters(queryParameters) {

    // Parse and return queryParameters as objects.
    return Object.assign( 
        ...Object.entries(Object(queryParameters)).map(([key, value]) => ({ 
            [key]: JSON.parse(value)
        }))
    )
}